import type { FC } from 'react';

type IconProps = {
    className?: string;
};

/**
 * キラキラ（スパークル）アイコン
 * 2つの星（大・小）で構成
 */
export const SparkleIcon: FC<IconProps> = ({ className }) => (
    <svg
        className={className}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden="true"
    >
        {/* 大きな星 */}
        <path
            d="M9.813 15.904L9 18.75l-.813-2.846a4.5 4.5 0 0 0-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 0 0 3.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 0 0 3.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 0 0-3.09 3.09Z"
            stroke="currentColor"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
        {/* 小さめの星（少しサイズアップ） */}
        <path
            d="M18.35 9.2 18 10.4l-.35-1.2a3.9 3.9 0 0 0-2.8-2.8L13.6 6l1.25-.35a3.9 3.9 0 0 0 2.8-2.8L18 1.6l.35 1.25a3.9 3.9 0 0 0 2.8 2.8L22.6 6l-1.25.35a3.9 3.9 0 0 0-2.8 2.85Z"
            stroke="currentColor"
            strokeWidth="1.4"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);
